import { resolveThoughtSummaryWithDuration } from '@/services/chatApi'
import { mergeAssistantMeta } from './mergeAssistantMeta.js'

/** @param {import('./runApiCompletionStream.js').ApiCompletionCtx & {
 *   fullText: string,
 *   blocksFromApi: unknown[] | null,
 *   assistantMeta: Record<string, unknown>,
 * }} ctx */
export function streamApiCompletionText(ctx) {
  const { tid, pendingId, fullText, blocksFromApi, assistantMeta, signal, session, setMessagesByThreadId } =
    ctx
  let currentLength = 0
  session.addInterval(() => {
    if (signal.aborted) {
      session.dispose()
      return
    }
    currentLength += Math.floor(Math.random() * 4) + 2
    if (currentLength >= fullText.length) currentLength = fullText.length
    const complete = currentLength >= fullText.length
    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const idx = list.findIndex((m) => m.id === pendingId)
      if (idx === -1) {
        session.dispose()
        return inner
      }
      const next = [...list]
      const prev = list[idx]
      const mergedMeta = complete ? mergeAssistantMeta(prev, assistantMeta) : {}
      const assistantPatch = complete
        ? {
            ...mergedMeta,
            thoughtSummary: resolveThoughtSummaryWithDuration(prev, mergedMeta),
            autoExpandPreamble: false,
            ...(blocksFromApi ? { blocks: blocksFromApi } : {}),
          }
        : {}
      next[idx] = {
        ...next[idx],
        text: fullText.slice(0, currentLength),
        createdAt: Date.now(),
        ...assistantPatch,
      }
      return { ...inner, [tid]: next }
    })
    if (complete) session.dispose()
  }, 15)
}
